import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
    ,FvmsExcelService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import { DtgManageTeamFormComponent } from "../form/dtg.manage.team.form.component";

@Component({
    selector: "dtg-manage-team-list"
    ,templateUrl: './dtg.manage.team.list.component.html'
    ,providers: []
})
export class DtgManageTeamListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    dayDiff:number=0;
    listTeam:any[];
    searchValue:string;
    @Input() listType:DtgListType = DtgListType.list;
    @Output() teamInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    
    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.pagingInfo.pageSize = 15;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : null
            ,searchValue : this.searchValue
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectTeam(teamInfo:any){
        this.teamInfo.emit(teamInfo);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    clickSearch(){
        this.reloadListItem();
    }

    clickOpenModalTeamInfo(dtgActionType:DtgActionType,teamInfo:any){
        let modalRef = this.modalService.open(
            DtgManageTeamFormComponent
            ,{
                centered:true
                // ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = teamInfo?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.teamId = teamInfo?.dtgTeamId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    exportExcel(){
        this.fvmsCommonService.setIsLoading(true);
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : null
            ,searchValue : this.searchValue
        };
        let paging = new PagingInfo();
        paging.pageSize=999999;
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,paging)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    let listItems = apiResponse.resultValue;
                    let listJson = this.convertExcelJson(listItems);
                    this.fvmsExcelService.excelDownload(listJson,"listGroup");
                    this.fvmsCommonService.setIsLoading(false);
                }
            });
    }

    convertExcelJson(dataList:any[]){
        return dataList.map((v,i) => {
            return {
                 "그룹이름":v.dtgTeamNm
                ,"위도":v.lat || "미설정"
                ,"경도":v.lng || "미설정"
                ,"주소":v.addr1 || "미설정"
            };
        });
    }
}